
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:grid;
  width:1.25em;
  width:var(--icon-size, 1.25em);
  height:1.25em;
  height:var(--icon-size, 1.25em);
}

:host svg{
  height:100%;
  width:100%;
  display:flex;
  fill:inherit;
  fill:var(--icon-fill, inherit);
  stroke:inherit;
  stroke:var(--icon-stroke, inherit);
  color:inherit;
  color:var(--icon-color, inherit);
}
`;